import React, { useState } from "react";
import { Select, DatePicker } from "antd";

const { RangePicker } = DatePicker;

function PeriodSelector({ handleChartGroupChage, chartGroup = '7d', selectedGroup, handleDataGroup, disabled = false }) {
    const [isCustomRange, setIsCustomRange] = useState(false);

    const handleSelectDurationChange = (newGroup) => {
        if (newGroup === '0') {
            setIsCustomRange(true);
        } else {
            setIsCustomRange(false);
            handleChartGroupChage(newGroup, false, null);
        }
    };

    const onChangeRange = (range) => {
        if (range) {
            handleChartGroupChage('0', true, range);
        }
    };

    return (
        <div>
            <Select
                value={chartGroup}
                style={{ width: '100%' }}
                size='small'
                placeholder="Select a duration"
                onChange={handleSelectDurationChange}
                disabled={disabled}
            >
                <Select.Option value="7d">7 Days</Select.Option>
                <Select.Option value="1m">1 Month</Select.Option>
                <Select.Option value="3m">3 Months</Select.Option>
                <Select.Option value="6m">6 Months</Select.Option>
                <Select.Option value="12m">12 Months</Select.Option>
                <Select.Option value="0">Custom Range</Select.Option>
            </Select>

            {isCustomRange && (
                <div className='gx-ml-0 gx-mt-2' style={{ width: '100%' }}>
                    <RangePicker
                        size='small'
                        style={{ width: '100%' }}
                        onChange={onChangeRange}
                    />
                </div>
            )}

            <div className='-card-full gx-mt-1 gx-flex-row'>
                <Select
                    value={selectedGroup}
                    style={{ width: '35%' }}
                    size='small'
                    placeholder="Select grouping"
                    onChange={handleDataGroup}
                    disabled={disabled}
                >
                    <Select.Option value="d">Daily</Select.Option>
                    <Select.Option value="w">Weekly</Select.Option>
                    <Select.Option value="m">Monthly</Select.Option>
                    <Select.Option value="y">Yearly</Select.Option>
                </Select>
            </div>
        </div>
    );
}

export default PeriodSelector;